/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AccountGroupFullInfo} from '../models/AccountGroupFullInfo';
import type {Error} from '../models/Error';
import type {GroupSaveResult} from '../models/GroupSaveResult';

export interface CreateNewGroup$Request {
    accountGroupFullInfo: AccountGroupFullInfo;
}

export interface CreateNewGroup$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const createNewGroupRequest = createAction<PayloadData<void, CreateNewGroup$Request>>('ACCOUNT_GROUP__CREATE_NEW_GROUP__REQUEST');
export const createNewGroupSuccess = createAction<PayloadData<GroupSaveResult, CreateNewGroup$Request>>('ACCOUNT_GROUP__CREATE_NEW_GROUP__SUCCESS');
export const createNewGroupFailure = createAction<PayloadData<Error, CreateNewGroup$Request, true>>('ACCOUNT_GROUP__CREATE_NEW_GROUP__FAILURE');

export const createNewGroupActions = [
    createNewGroupRequest,
    createNewGroupSuccess,
    createNewGroupFailure
] as const;

/**
 * @param {AccountGroupFullInfo} meta.accountGroupFullInfo
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const createNewGroup = (meta: CreateNewGroup$Request, config?: CreateNewGroup$Config) => {
    return {
        CALL_API: {
            types: createNewGroupActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/groups`,
            TRANSPORT_REQUEST_BODY: meta.accountGroupFullInfo,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface DeleteGroup$Request {
    groupId: number;
}

export interface DeleteGroup$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const deleteGroupRequest = createAction<PayloadData<void, DeleteGroup$Request>>('ACCOUNT_GROUP__DELETE_GROUP__REQUEST');
export const deleteGroupSuccess = createAction<PayloadData<void, DeleteGroup$Request>>('ACCOUNT_GROUP__DELETE_GROUP__SUCCESS');
export const deleteGroupFailure = createAction<PayloadData<Error, DeleteGroup$Request, true>>('ACCOUNT_GROUP__DELETE_GROUP__FAILURE');

export const deleteGroupActions = [
    deleteGroupRequest,
    deleteGroupSuccess,
    deleteGroupFailure
] as const;

/**
 * @param {number} meta.groupId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const deleteGroup = (meta: DeleteGroup$Request, config?: DeleteGroup$Config) => {
    return {
        CALL_API: {
            types: deleteGroupActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/groups/${meta.groupId}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetGroupFullInfo$Request {
    groupId: number;
}

export interface GetGroupFullInfo$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getGroupFullInfoRequest = createAction<PayloadData<void, GetGroupFullInfo$Request>>('ACCOUNT_GROUP__GET_GROUP_FULL_INFO__REQUEST');
export const getGroupFullInfoSuccess = createAction<PayloadData<AccountGroupFullInfo, GetGroupFullInfo$Request>>('ACCOUNT_GROUP__GET_GROUP_FULL_INFO__SUCCESS');
export const getGroupFullInfoFailure = createAction<PayloadData<Error, GetGroupFullInfo$Request, true>>('ACCOUNT_GROUP__GET_GROUP_FULL_INFO__FAILURE');

export const getGroupFullInfoActions = [
    getGroupFullInfoRequest,
    getGroupFullInfoSuccess,
    getGroupFullInfoFailure
] as const;

/**
 * @param {number} meta.groupId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getGroupFullInfo = (meta: GetGroupFullInfo$Request, config?: GetGroupFullInfo$Config) => {
    return {
        CALL_API: {
            types: getGroupFullInfoActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/groups/${meta.groupId}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UpdateGroup$Request {
    groupId: number;
    accountGroupFullInfo: AccountGroupFullInfo;
}

export interface UpdateGroup$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateGroupRequest = createAction<PayloadData<void, UpdateGroup$Request>>('ACCOUNT_GROUP__UPDATE_GROUP__REQUEST');
export const updateGroupSuccess = createAction<PayloadData<void, UpdateGroup$Request>>('ACCOUNT_GROUP__UPDATE_GROUP__SUCCESS');
export const updateGroupFailure = createAction<PayloadData<Error, UpdateGroup$Request, true>>('ACCOUNT_GROUP__UPDATE_GROUP__FAILURE');

export const updateGroupActions = [
    updateGroupRequest,
    updateGroupSuccess,
    updateGroupFailure
] as const;

/**
 * @param {number} meta.groupId
 * @param {AccountGroupFullInfo} meta.accountGroupFullInfo
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateGroup = (meta: UpdateGroup$Request, config?: UpdateGroup$Config) => {
    return {
        CALL_API: {
            types: updateGroupActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/groups/${meta.groupId}`,
            TRANSPORT_REQUEST_BODY: meta.accountGroupFullInfo,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

